import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export { default } from './index'

export async function getServerSideProps(context) {
  const { locale } = context
  return {
    props: {
      ...(await serverSideTranslations(locale))
    }
  }
}
